import { AngularFireStorage, AngularFireStorageModule } from '@angular/fire/storage';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './components/verify-email/verify-email.component';
import { FormsModule } from '@angular/forms';

import { AuthService } from "./shared/services/auth.service";
import { NavComponent } from './nav/nav.component';
import { FooterComponent } from './footer/footer.component';
import { LedgerComponent } from './ledger/ledger.component';
import { BalanceSheetComponent } from './balance-sheet/balance-sheet.component';
import { IncomeStatementComponent } from './income-statement/income-statement.component';
import { StorageComponent } from './storage/storage.component';
import { SenseComponent } from './sense/sense.component';
import { SalesComponent } from './sales/sales.component';
import { OrdersComponent } from './orders/orders.component';
import { PrivilegeComponent } from './components/privilege/privilege.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { MessagesComponent } from './components/messages/messages.component';
import { LedgerArComponent } from './ledger-ar/ledger-ar.component';
import { LedgerApComponent } from './ledger-ap/ledger-ap.component';
import { LedgerCostComponent } from './ledger-cost/ledger-cost.component';
import { CashStatementComponent } from './cash-statement/cash-statement.component';
import { StorageMaterialComponent } from './storage-material/storage-material.component';

var config = {
  apiKey: "AIzaSyCdNCQ6GSEEIvsrMKVLBNvZLLj3cusb1c4",
  authDomain: "emei-co.firebaseapp.com",
  databaseURL: "https://emei-co.firebaseio.com",
  projectId: "emei-co",
  storageBucket: "emei-co.appspot.com",
  messagingSenderId: "54329774021",
  appId: "1:54329774021:web:cb0010c320c927698205ac",
  measurementId: "G-YGVN5QYC87"
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    NavComponent,
    FooterComponent,
    LedgerComponent,
    BalanceSheetComponent,
    IncomeStatementComponent,
    StorageComponent,
    SenseComponent,
    SalesComponent,
    OrdersComponent,
    PrivilegeComponent,
    LandingPageComponent,
    MessagesComponent,
    LedgerArComponent,
    LedgerApComponent,
    LedgerCostComponent,
    CashStatementComponent,
    StorageMaterialComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(config),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    FormsModule   
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
